import React from 'react';
import { AnimatedSection } from './AnimatedSection';
import { ClockIcon, ThermometerIcon, SunMoonIcon } from 'lucide-react';
export function MethodSection() {
  return <section className="relative bg-night-900 py-20 md:py-28 overflow-hidden" data-id="element-114">
      {/* Radial glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] rounded-full" style={{
      background: 'radial-gradient(circle, rgba(245,197,66,0.08) 0%, transparent 70%)'
    }} aria-hidden="true" data-id="element-115" />

      <div className="relative z-10 max-w-3xl mx-auto px-5 sm:px-8" data-id="element-116">
        <AnimatedSection data-id="element-117">
          <div className="text-center mb-12" data-id="element-118">
            <span className="inline-block px-4 py-1.5 rounded-full bg-gold-400/10 border border-gold-400/20 text-gold-400 text-sm font-dm-sans font-medium mb-6" data-id="element-119">
              El Mecanismo Único
            </span>
            <h2 className="font-playfair text-3xl sm:text-4xl md:text-5xl font-bold text-cream-100 mb-6" data-id="element-120">
              El Ritmo Natural del Sueño
            </h2>
            <p className="font-dm-sans text-lg text-cream-200/70 leading-relaxed max-w-2xl mx-auto" data-id="element-121">
              A diferencia de los entrenamientos militares de sueño, este
              sistema se basa en la{' '}
              <strong className="text-cream-100" data-id="element-122">cronobiología</strong> — la
              ciencia que estudia los ritmos naturales del cuerpo.
            </p>
          </div>
        </AnimatedSection>

        {/* Key concept card */}
        <AnimatedSection delay={100} data-id="element-123">
          <div className="bg-gradient-to-br from-night-700/80 to-night-800/80 border border-gold-400/20 rounded-2xl p-8 md:p-10 mb-12" data-id="element-124">
            <div className="flex items-center gap-3 mb-5" data-id="element-125">
              <div className="w-10 h-10 rounded-full bg-gold-400/15 flex items-center justify-center" data-id="element-126">
                <ClockIcon className="w-5 h-5 text-gold-400" data-id="element-127" />
              </div>
              <h3 className="font-playfair text-2xl font-bold text-gold-400" data-id="element-128">
                La "Ventana de Oro"
              </h3>
            </div>
            <p className="font-dm-sans text-base sm:text-lg text-cream-200/80 leading-relaxed" data-id="element-129">
              Un espacio de{' '}
              <strong className="text-cream-100" data-id="element-130">15 minutos</strong> donde el
              cerebro de tu bebé libera melatonina de forma natural — para
              lograr que se duerma <em className="text-gold-400" data-id="element-131">sin lucha</em>.
            </p>
          </div>
        </AnimatedSection>

        {/* Two pillars */}
        <div className="grid sm:grid-cols-2 gap-6" data-id="element-132">
          <AnimatedSection delay={150} data-id="element-133">
            <div className="bg-night-700/40 border border-night-600/40 rounded-xl p-6 h-full" data-id="element-134">
              <div className="w-10 h-10 rounded-full bg-night-600/60 flex items-center justify-center mb-4" data-id="element-135">
                <ThermometerIcon className="w-5 h-5 text-cream-200/70" data-id="element-136" />
              </div>
              <h4 className="font-playfair text-xl font-semibold text-cream-100 mb-3" data-id="element-137">
                Temperatura corporal
              </h4>
              <p className="font-dm-sans text-sm text-cream-200/60 leading-relaxed" data-id="element-138">
                Sincronizamos la temperatura de su cuerpo y su entorno para que
                su organismo entienda que la noche es para descansar.
              </p>
            </div>
          </AnimatedSection>

          <AnimatedSection delay={200} data-id="element-139">
            <div className="bg-night-700/40 border border-night-600/40 rounded-xl p-6 h-full" data-id="element-140">
              <div className="w-10 h-10 rounded-full bg-night-600/60 flex items-center justify-center mb-4" data-id="element-141">
                <SunMoonIcon className="w-5 h-5 text-cream-200/70" data-id="element-142" />
              </div>
              <h4 className="font-playfair text-xl font-semibold text-cream-100 mb-3" data-id="element-143">
                Entorno sensorial
              </h4>
              <p className="font-dm-sans text-sm text-cream-200/60 leading-relaxed" data-id="element-144">
                Ajustamos luz, sonido y estímulos para que su cuerpo entienda,
                por fin, que el día es para jugar y la noche para descansar.
              </p>
            </div>
          </AnimatedSection>
        </div>
      </div>
    </section>;
}